<template>
  <li class="nav-toc-item">
    <a href="#" @click.prevent="showSection()">{{ item.name }}</a>
    <ul v-if="item.children">
      <Section v-for="child in item.children" :key="child.id" :item="child" />
    </ul>
  </li>
</template>

<script>
export default {
  name: "Section",
  props: ["item"],
  created() {
    //console.log(this.item);
  },
  data() {
    return {
      isActive: false
    };
  },
  methods: {
    showSection() {
      this.$store.commit("resources/setSection", this.item);
      this.$store
        .dispatch("resources/fetchResources", this.item.uuid)
        .then()
        .catch(err => {});
    }
  }
};
</script>

<style>
</style>